import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${props => props.theme.brand_primary_color};
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  text-align: center;
  padding: 27px;

  img {
    width: 200px;
    margin-bottom: 40px;
  }
`;

export const Card = styled.div`
  border-radius: 5px;
  background: ${props => props.theme.interface1};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  margin: 0 auto;
  max-width: 434px;
  padding: 30px;
  text-align: center;

  h3 {
    color: ${props =>
      props.theme.darkMode ? props.theme.interface4 : props.theme.interface7};
  }

  p {
    font-size: 16px;
    font-weight: 400;
    color: ${props => props.theme.interface5};
  }

  button {
    font-size: 16px;
  }
`;
